export enum BuildLevel {
    Dev = 1,
    Prod,
}

export const Config = {
    GameVersion: "web1.1.5",
    BuildLevel: BuildLevel.Prod,
    AnalyticsEnabled: false,
}